import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Editor, { loader } from '@monaco-editor/react';

// A Monaco Editor fájljait a tools/copy-editors.js másolja a public/monaco mappába (nem CDN-ről töltjük).
loader.config({ paths: { vs: '/monaco/vs' } });

const VALTOZOK = [
    ['megrendeles.Csoportjegykod', 'belépési kód'],
    ['megrendeles.osszAr', 'a jegyek ára összesen'],
    ['megrendeles.Szamlaszam', 'számla száma'],
    ['megrendeles.Szamlaurl', 'számla letöltési címe'],
    ['megrendeles.felhasznalo.Nev', 'a megrendelő neve'],
    ['megrendeles.felhasznalo.Email', 'a megrendelő e-mail-címe'],
    ['megrendeles.rendezveny.Cim', 'a rendezvény címe'],
    ['megrendeles.rendezveny.Kezdes', 'a rendezvény kezdése (pl. 2026. november 9. 18.00)'],
    ['megrendeles.rendezveny.Datumidokezdet', 'a rendezvény kezdete (szöveg)'],
    ['megrendeles.rendezveny.Infohtmlrovid', 'rövid információ (HTML: |raw)'],
    ['megrendeles.rendezveny.Infohtmlhosszu', 'hosszú információ (HTML: |raw)'],
    ['megrendeles.rendezveny.Megrendelestorolheto', '1, ha a megrendelés törölhető'],
    ['megrendeles.jegyTipusDarabszamokByID', 'jegytípusok: ciklus, elemei: db, Nev, Arnetto'],
    ['megrendeles.jegyek', 'vendégek: ciklus, elemei: Vendegneve, jegyTipus.Nev, jegyTipus.Rendezvenyreszlatogato, reszLatogatasok'],
    ['  jegy.reszLatogatasok', 'elemei: Sorszam, rendezvenyResz.Nev / Helyszin / Idokezdet / Idoveg'],
];

const KIEGESZITES = [
    '{% if feltétel %} … {% else %} … {% endif %}',
    '{% for elem in lista %} … {% endfor %}',
    '{% set név = érték %}',
    '{{ változó }}      (HTML-escape-elve)',
    '{{ változó|raw }}   (HTML-ként)',
];

// Teljes képernyős Twig-szerkesztő (Monaco) a megrendelés-áttekintő sablonokhoz. Új sablon: sablonID nélkül.
export default function AttekintoSablonSzerkeszto({ sablonID, callAPI, onHide, onMentve }) {
    const [sablon, setSablon] = useState(undefined);   // {Id?, Nev, Tartalom}
    const [hiba, setHiba] = useState(undefined);
    const [valtozott, setValtozott] = useState(false);
    const tartalomRef = useRef('');

    useEffect(() => {
        if (sablonID === undefined) {
            const kezdo = { Id: null, Nev: '', Tartalom: '<div>\n    {{ megrendeles.rendezveny.Cim }}\n</div>\n' };
            tartalomRef.current = kezdo.Tartalom;
            setSablon(kezdo);
        } else {
            callAPI('General.getAttekintoSablon', { sablonID: sablonID }, function (resp) {
                tartalomRef.current = resp.data.sablon.Tartalom;
                setSablon(resp.data.sablon);
            }, function () {
                onHide();
            });
        }
    }, []);

    function onClick_mentes() {
        const adat = { Nev: sablon.Nev, Tartalom: tartalomRef.current };
        if (sablon.Id !== null) {
            adat.Id = sablon.Id;
        }
        callAPI('General.saveAttekintoSablon', adat, function (resp) {
            setValtozott(false);
            onMentve(resp.data.sablon);
        }, function (resp) {
            setHiba(String(resp.userMsg || 'A mentés nem sikerült.'));
            return false;   // a hiba a panelben látszik
        });
    }

    function onClick_bezaras() {
        if (valtozott && !window.confirm('A módosítások nincsenek mentve. Biztosan bezárja?')) {
            return;
        }
        onHide();
    }

    return (
        <Modal show={true} fullscreen onHide={onClick_bezaras} backdrop="static" keyboard={false} dialogClassName="sablonSzerkesztoDialog">
            <Modal.Header closeButton>
                <Modal.Title>
                    {sablon === undefined ? 'Sablon' : (sablon.Id === null ? 'Új sablon' : 'Sablon szerkesztése')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="sablonSzerkesztoTest">
                {sablon === undefined ? <div className="adminUres">Betöltés…</div> :
                    <>
                        <div className="sablonNevSor">
                            <Form.Label htmlFor="sablonNev">Sablon neve</Form.Label>
                            <Form.Control id="sablonNev" type="text" maxLength={100} value={sablon.Nev}
                                onChange={function (e) { setSablon(Object.assign({}, sablon, { Nev: e.target.value })); setValtozott(true); setHiba(undefined); }} />
                        </div>
                        <div className="sablonMunkaterulet">
                            <div className="sablonKod">
                                <Editor
                                    height="100%"
                                    language="twig"
                                    theme="vs-dark"
                                    defaultValue={sablon.Tartalom}
                                    onChange={function (ertek) { tartalomRef.current = ertek || ''; setValtozott(true); setHiba(undefined); }}
                                    options={{
                                        fontSize: 18,
                                        lineHeight: 28,
                                        fontFamily: 'Consolas, "Cascadia Mono", "Courier New", monospace',
                                        fontLigatures: false,
                                        minimap: { enabled: false },
                                        wordWrap: 'on',
                                        tabSize: 4,
                                        insertSpaces: true,
                                        renderWhitespace: 'boundary',
                                        scrollBeyondLastLine: false,
                                        automaticLayout: true,
                                        padding: { top: 12, bottom: 12 },
                                    }} />
                            </div>
                            <div className="sablonSegito">
                                <div className="sablonSegitoCim">Használható változók</div>
                                <dl>
                                    {VALTOZOK.map(function (v) {
                                        return (
                                            <React.Fragment key={v[0]}>
                                                <dt>{'{{ ' + v[0].trim() + ' }}'}</dt>
                                                <dd>{v[1]}</dd>
                                            </React.Fragment>
                                        );
                                    })}
                                </dl>
                                <div className="sablonSegitoCim">Szerkezetek</div>
                                <pre>{KIEGESZITES.join('\n')}</pre>
                                <div className="sablonSegitoMegjegyzes">
                                    A sablon Twig. Biztonsági okból csak az egyszerű szerkezetek (if, for, set) és szűrők
                                    (pl. raw, upper, lower, default, number_format, join, length, replace) használhatók;
                                    az include és a hasonló tagek nem. Mentéskor a sablon mintaadattal lefut, a hibákat
                                    a sor számával jelezzük.
                                </div>
                            </div>
                        </div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                {hiba !== undefined ? <div className="sablonHiba">{hiba}</div> : undefined}
                <Button variant="outline-secondary" onClick={onClick_bezaras}>Bezárás</Button>
                <Button variant="primary" disabled={sablon === undefined} onClick={onClick_mentes}>Mentés</Button>
            </Modal.Footer>
        </Modal>
    );
}
